
import { useEffect } from "react";
export default function PhosphorIconInit() {

  useEffect(() => {
    var head = document.getElementsByTagName("head")[0];

    // Only the weights the app uses (ph, ph-bold, ph-fill); thin, light and
    // duotone were three more stylesheets and fonts nothing drew with.
    for (const weight of ["regular", "bold", "fill"]) {
      var link = document.createElement("link");
      link.rel = "stylesheet";
      link.type = "text/css";
      link.href =
        "https://unpkg.com/@phosphor-icons/web@2.1.1/src/" + weight + "/style.css";
      head.appendChild(link);
    }
  }, [])

  return null
}
